<script>
import Navbar from '@/components/Navbar.vue'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'

export default {
  name: 'TrailersByParkings',
  components: { RefreshButton, Navbar },
  data () {
    return {
      parkingsWithTrailers: [],
      filteredParkingsWithTrailers: [],
      searchText: '',
      refreshing: false,
      isSearchVisible: false
    }
  },
  created () {
    emitter.on('refreshed', this.fetchParkingsWithTrailers)
    window.addEventListener('scroll', this.scrollFunction)
    this.fetchParkingsWithTrailers()
  },
  methods: {
    async fetchParkingsWithTrailers () {
      this.refreshing = true

      try {
        this.parkingsWithTrailers = this.filteredParkingsWithTrailers = (await $axios.get('Parking/WithTrailers')).data.filter(p => !p.hidden).sort((a, b) => a.name.localeCompare(b.name)).sort((a, b) => a.trailers.length && !b.trailers.length ? -1 : 1)
        this.filterParkings()
      } catch (e) {
        await Swal.fire('Nie udało się pobrać listy parkingów, proszę spróbować ponownie', '', 'error')
      } finally {
        this.refreshing = false
      }
    },

    async hideParking (id) {
      const putData = { hidden: true }

      try {
        await $axios.put(`Parking/${id}`, putData)
        await this.fetchParkingsWithTrailers()
        await Swal.fire('Ukryto wybrany parking', '', 'success')
      } catch (e) {
        await Swal.fire('Nie udało się ukryć parkingu', '', 'error')
      }
    },

    filterParkings () {
      if (this.searchText.length > 0) {
        this.filteredParkingsWithTrailers = this.parkingsWithTrailers.filter(p => {
          let found = false

          if (p.name.toLowerCase().includes(this.searchText.toLowerCase())) {
            found = true
          }

          p.trailers.map(t => {
            if (t.plateNumber.toLowerCase().includes(this.searchText.toLowerCase())) {
              found = true
            }
          })

          return found
        })
      } else {
        this.closeFiltering()
      }
    },

    closeFiltering () {
      this.searchText = ''
      this.fetchParkingsWithTrailers()
    },

    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },

    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<template>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <a href="#" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="closeFiltering">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </a>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" placeholder="Filtruj parkingi" @input="filterParkings">
        </div>
      </div>
      <RefreshButton :refreshing="refreshing"/>
    </div>
    <hr>
    <div class="row py-3">
      <div class="d-lg-flex justify-content-between">
        <h5 class="fw-bold">
          NACZEPY WEDŁUG PARKINGÓW
        </h5>
      </div>
    </div>

    <div class="row">
      <div class="col-3 mt-5 border border-2" v-for="parkingWithTrailers in filteredParkingsWithTrailers" :key="parkingWithTrailers.id">
        <div class="text-start fw-bold text-primary my-2 d-flex justify-content-between align-items-center mb-2">
          <div>
            {{ parkingWithTrailers.name }}
          </div>
          <button v-if="!parkingWithTrailers.trailers.length" class="btn btn-sm btn-success" @click="hideParking(parkingWithTrailers.id)">Ukryj parking</button>
          <span v-else class="text-danger fw-bold">Nie można ukryć parkingu, na którym są naczepy</span>
        </div>
        <ul class="list-group mb-3">
          <li class="list-group-item" v-for="trailer in parkingWithTrailers.trailers.sort((a, b) => a.plateNumber.localeCompare(b.plateNumber))" :key="trailer.id">{{ trailer.plateNumber }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
